import { IErrorWithSentryId } from 'interfaces/IErrorWithSentryId';

export function incluirSentryIdMsgErro(errorWithSentryID: IErrorWithSentryId | undefined | null): string {
  if (errorWithSentryID?.response?.data?.sentryId) {
    return `Código do erro : ${errorWithSentryID.response.data.sentryId} .`;
  }
  return '';
}
